import { globalSettings, isUndNullEmp } from '../../helpers/settings';

const dateTimeStr = new Date()?.toISOString();
const str = '';

const noImagePath = '/images/noImage.png';
const currentMethod = 'userModelGet';

export const userModelGet = ({ url = '', }) => {
    return {
        accountApproved: false,
        accountApprovedDate: dateTimeStr,
        accountApprovedUserId: str,
        //apartmentId: str,
        contracts: [],
        created: dateTimeStr,
        email: str,
        emailVerified: false,
        emailVerifiedDate: dateTimeStr,
        emailVerifiedIsSend: false,
        emailVerifiedIsSendDate: dateTimeStr,
        firstName: str,
        isDeleted: false,
        isDeletedDate: dateTimeStr,
        isDeletedRemark: str,
        isDeletedUserId: str,
        isDisabled: false,
        isDisabledDate: dateTimeStr,
        isDisabledRemark: str,
        isDisabledUserId: str,
        lastName: str,
        //peopleTypeId: str,
        phoneNumber: str,
        photoName: str,
        //photoURL: str,
        photoURL: `${isUndNullEmp({ data: url, subMethod: currentMethod, })?.result ?
            globalSettings?.app?.url :
            url
            }${noImagePath}`,
        roleDate: dateTimeStr,
        roleId: str,
        roleUserId: str,
        urlForgotPasswordEmail: str,
        urlVerificationEmail: str,
    }
};